export default {
      id: "arrow-long-right-usage",
      viewBox: "0 0 19 19",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#arrow-long-right",
      toString: function () {
        return this.url;
      }
    }